import { render, staticRenderFns } from "./YouthStaffList.vue?vue&type=template&id=3c815c54"
import script from "./YouthStaffList.vue?vue&type=script&lang=js"
export * from "./YouthStaffList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports